import React, { useEffect, useRef, useState } from 'react';
import { UsersAPI } from 'bpm-client-api';
import { Button } from '../buttons';
import AnimateHeight from 'react-animate-height';
import { Loader } from '../utility';
function methodToDisplay(method) {
    if (method == 'system') {
        return 'System';
    }
    else if (method == 'authorize' || method == 'payment-card') {
        return 'Credit Card';
    }
    else {
        return 'Paypal';
    }
}
var OrderHistory = function (props) {
    var _a;
    var _b = useState(), height = _b[0], setHeight = _b[1];
    var _c = useState(600), animate = _c[0], setAnimate = _c[1];
    var _d = useState(false), showMore = _d[0], setShowMore = _d[1];
    var orderRow = useRef(null);
    var header = useRef(null);
    useEffect(function () {
        if (!orderRow.current) {
            return;
        }
        //* + 1 for border & -1 because we set last border to display: none
        if (props.invoices.length > 10) {
            setHeight(((orderRow.current.scrollHeight + 1) * 10) - 1);
        }
        else {
            setHeight(((orderRow.current.scrollHeight + 1) * props.invoices.length) - 1);
        }
    }, [props.invoices, orderRow.current]);
    return (React.createElement("div", { className: "OrderHistory" },
        React.createElement("div", { className: "header", ref: header },
            React.createElement("span", { className: "column column-1" }, "DATE"),
            React.createElement("span", { className: "column column-2" }, "REFERENCE"),
            React.createElement("span", { className: "column column-3" }, "PRICE"),
            React.createElement("span", { className: "column column-4" }, "RECEIPT")),
        !height &&
            React.createElement(Loader, { centered: true, style: { marginTop: '10%' } }),
        React.createElement(AnimateHeight, { height: height, duration: animate, className: "AnimateHeight " + (!height ? 'hidden' : '') }, (_a = props.invoices) === null || _a === void 0 ? void 0 : _a.map(function (receipt, index) {
            return (React.createElement("div", { className: "order-row", key: receipt.id, ref: orderRow },
                React.createElement("span", { className: "column column-1" }, new Date(receipt.created_at).toLocaleDateString()),
                React.createElement("span", { className: "column column-2" },
                    receipt.id,
                    " - ",
                    methodToDisplay(receipt.method),
                    " ",
                    receipt.plan_name,
                    " ",
                    receipt.mode == 'a' ? 'Subscription' : 'one time payment'),
                React.createElement("span", { className: "column column-3" }, "$" + parseFloat(receipt.paid_amount).toFixed(2)),
                React.createElement("div", { className: "column column-4" },
                    React.createElement("span", { className: "PDF", onClick: function () {
                            window.location.assign(UsersAPI.getInvoiceLink(receipt.id, true));
                        } }, "PDF"))));
        })),
        height && (props.invoices.length > 10) && !showMore
            ?
                React.createElement(Button, { className: "load-more", buttonText: 'Show More', onClick: function () {
                        var _a;
                        if (orderRow.current) {
                            setHeight(((orderRow.current.scrollHeight + 1) * ((_a = props.invoices) === null || _a === void 0 ? void 0 : _a.length)) - 1);
                            setShowMore(true);
                        }
                    } })
            : showMore &&
                React.createElement(Button, { className: "load-more", buttonText: 'Show Less', onClick: function () {
                        if (orderRow.current) {
                            setHeight(((orderRow.current.scrollHeight + 1) * 10) - 1);
                            setShowMore(false);
                            window.scrollTo({
                                top: header.current.offsetTop - 100,
                                behavior: 'smooth'
                            });
                        }
                    } })));
};
export default OrderHistory;
//# sourceMappingURL=OrderHistory.js.map